<template>
    <b-list-group-item v-on:click.stop="expandMenu()" :class="{'expanded': expanded}" class="flex-column align-items-start" >
        <div class="d-flex w-100 justify-content-between align-items-center">
            <router-link v-if="hasRoute" :to="item.route">
                <span>{{ item.text }}</span>
            </router-link>
            <span v-if="!hasRoute">{{ item.text }}</span>
            <b-badge v-if="hasChildren" variant="primary" pill>{{ item.children.length }}</b-badge>
        </div>
        
        <nav-tree v-if="expanded" :items="item.children"></nav-tree>
    </b-list-group-item>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      expanded: false,
      route: null
    };
  },

  computed: {
    hasRoute: function() {
      if (_.has(this.item, "route")) {
        return true;
      }
      return false;
    },
    hasChildren: function() {
      if (_.has(this.item, "children") && this.item.children.length > 0) {
        return true;
      }
      return false;
    },
    hasAction: function() {
      if (_.has(this.item, "action") && this.item.action.length > 0) {
        return true;
      }
      return false;
    },
    hasIcon: function() {
      if (_.has(this.item, "icon") && this.item.icon !== "") {
        return true;
      }
      return false;
    }
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    selected: {
      required: false
    }
  },

  methods: {
    expandMenu: function() {
      if (this.hasChildren) {
        this.expanded = !this.expanded;
      }
    },
    callAction: function() {
      if (this.hasAction) {
        //emit action
      }
    }
  },

  created() {
    if (this.selected == this.item.id) {
      this.expandMenu();
    }
  }
};
</script>

<style>
</style>
